import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import {
  DSAction,
  useActionsTableContext,
} from '../../../../ActionsTableContext'
import { useEditDsActionMutation } from 'schema'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { EditFormItemsValues } from '../../components/CreateEditFormItems/types'

export function useEdit(): EditRowActionOptions<DSAction, EditFormItemsValues> {
  const { refetch } = useActionsTableContext()
  const [edit] = useEditDsActionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editDSAction: {
        action: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditDesignSubmittalAction,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, description }) => ({
        name,
        description: description,
      }),
      onOk: async (
        { id, name: prevName, description: prevDescription },
        { name, description }
      ) => {
        if (prevName !== name || prevDescription !== description) {
          await edit({
            variables: { input: { id, name, description } },
          })
          refetch()
        }
      },
    },
  }
}
